import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./OperationHoursForm";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {cancelSetOperationHours} from "../../../actions/InventoryApiActions";
import {fromJS, Map, List} from "immutable";
import {validatePresence} from "../../../lib/Validators";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";

const TIME_INTERVALS = List(["00:00:00", "00:30:00", "01:00:00", "01:30:00", "02:00:00", "02:30:00", "03:00:00", "03:30:00", "04:00:00", "04:30:00", "05:00:00", "05:30:00", "06:00:00", "06:30:00", "07:00:00", "07:30:00", "08:00:00", "08:30:00", "09:00:00", "09:30:00", "10:00:00", "10:30:00", "11:00:00", "11:30:00", "12:00:00", "12:30:00", "13:00:00", "13:30:00", "14:00:00", "14:30:00", "15:00:00", "15:30:00", "16:00:00", "16:30:00", "17:00:00", "17:30:00", "18:00:00", "18:30:00", "19:00:00", "19:30:00", "20:00:00", "20:30:00", "21:00:00", "21:30:00", "22:00:00", "22:30:00", "23:00:00", "23:30:00"]);

function generateTimes() {
  return TIME_INTERVALS.map(time => {
    return Map({value: time, title: time.substr(0,5)});
  })
}

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "openingTime");
  errors = validatePresence(errors, values, "closingTime");
  errors = validatePresence(errors, values, "timezone");

  return errors.toJS();
}

class SetOperationHoursFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = values.set("id", this.props.id);
    return this.props.setWarehouseOperationHours(updatedValues.toJS())
      .then((response) => {
        if (response.data.setWarehouseOperationHours.errors.length <= 0) {
          this.props.cancelSetOperationHours();
        } else {
          let errors = createValidationErrors(response.data.setWarehouseOperationHours.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelSetOperationHours();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    let timezones = fromJS(data.timezones);
    let warehouse = fromJS(data.warehouse);

    let initialValues = Map();
    if (warehouse.get("hasOperationHours") === true) {
      initialValues = Map({
        openingTime: warehouse.get("openingTime"),
        closingTime: warehouse.get("closingTime"),
        timezone: warehouse.get("timezone")
      })
    }

    return (
      <Form
        initialValues={initialValues}
        timezones={timezones}
        times={generateTimes()}
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}


const SET_WAREHOUSE_OPERATION_HOURS = gql`
  mutation setWarehouseOperationHours($data: WarehouseOperationHoursInput!) {
    setWarehouseOperationHours(input: $data) {
      errors { key message }
    }
  }
`;

const GET_TIMEZONES_AND_WAREHOUSE = gql`
  query timezonesAndWarehouse($warehouseId:ID!) {
    timezones {
      value
    }
    warehouse(warehouseId:$warehouseId) {
      id
      hasOperationHours
      openingTime
      closingTime
      timezone
    }
  }
`;

const withQueries = compose(
  graphql(GET_TIMEZONES_AND_WAREHOUSE, {
    options: (props) => ({
      variables: {
        warehouseId: props.id
      }
    })
  }),
  graphql(SET_WAREHOUSE_OPERATION_HOURS, {
    props: ({ mutate }) => ({
      setWarehouseOperationHours: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

export default connect(null, {cancelSetOperationHours})(withQueries(SetOperationHoursFormContainer));